module.exports = __webpack_public_path__ + "media/sound_win.e084a704.wav";